import Vue from 'vue'
import store from '../store/index'
import { formatCurrency } from '@src/helper'

Vue.filter('currency', function (value) {
  const currencySymbol = store.getters['app/currency']
  return formatCurrency(value, {
    symbol: currencySymbol,
    useLocale: true,
    nullValue: 'N/A'
  })
})

// Simple currency filter for cases where we want to format with $ prefix
Vue.filter('currencySimple', function (value) {
  return formatCurrency(value, {
    nullValue: 'N/A'
  })
})
